import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/SEOHead';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  author: string;
  readTime: string;
  image: string;
}

export default function Blog() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://auralisconsulting.io';
  
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Corporate Strategy', 'Tax Optimization', 'International Business', 'IT Management', 'Business Insights'];

  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: 'Strategic Planning in the UAE: Key Considerations for 2024',
      excerpt: 'Discover the essential elements of corporate strategy planning for businesses operating in the UAE market, including regulatory compliance, market positioning, and growth opportunities in Ras Al Khaimah.',
      content: 'Full article content...',
      category: 'Corporate Strategy',
      date: '2024-12-15',
      author: 'Auralis Consulting Team',
      readTime: '5 min read',
      image: 'https://public.readdy.ai/ai/img_res/6cbe5ce46760ba237480e8fc740b4ce8.jpg'
    },
    {
      id: 2,
      title: 'Tax Optimization Strategies for International Businesses in RAK',
      excerpt: 'Learn how international companies can leverage Ras Al Khaimah\'s favorable tax environment to optimize their global tax structure while maintaining full compliance with UAE regulations.',
      content: 'Full article content...',
      category: 'Tax Optimization',
      date: '2024-12-10',
      author: 'Tax Advisory Team',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=Professional%20tax%20consultant%20reviewing%20financial%20documents%20and%20tax%20optimization%20strategies%20with%20calculator%20and%20laptop%20on%20clean%20modern%20desk%2C%20bright%20office%20environment%20with%20organized%20paperwork%20and%20digital%20tools%2C%20business%20professional%20atmosphere&width=800&height=500&seq=blog2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Setting Up Your Business in UAE Free Zones: A Complete Guide',
      excerpt: 'A comprehensive guide to establishing your international business in UAE free zones, covering legal requirements, licensing procedures, and strategic advantages of different free zone locations.',
      content: 'Full article content...',
      category: 'International Business',
      date: '2024-12-05',
      author: 'Business Setup Specialists',
      readTime: '10 min read',
      image: 'https://readdy.ai/api/search-image?query=Modern%20UAE%20free%20zone%20business%20district%20with%20contemporary%20office%20buildings%20and%20international%20flags%2C%20professional%20business%20environment%20showing%20company%20registration%20and%20setup%20process%2C%20clean%20architectural%20design%20with%20blue%20sky%20background&width=800&height=500&seq=blog3&orientation=landscape'
    },
    {
      id: 4,
      title: 'Cybersecurity Best Practices for Growing Businesses',
      excerpt: 'Essential cybersecurity measures every growing business should implement to protect their IT infrastructure, sensitive data, and maintain business continuity in an increasingly digital landscape.',
      content: 'Full article content...',
      category: 'IT Management',
      date: '2024-11-28',
      author: 'IT Security Team',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=IT%20security%20professional%20monitoring%20network%20security%20systems%20on%20multiple%20screens%20showing%20cybersecurity%20dashboards%20and%20data%20protection%20interfaces%2C%20modern%20technology%20operations%20center%20with%20blue%20lighting%20and%20advanced%20monitoring%20equipment&width=800&height=500&seq=blog4&orientation=landscape'
    },
    {
      id: 5,
      title: 'Digital Transformation: Modernizing Your Business Operations',
      excerpt: 'How digital transformation can revolutionize your business processes, improve operational efficiency, and create competitive advantages in today\'s technology-driven marketplace.',
      content: 'Full article content...',
      category: 'Business Insights',
      date: '2024-11-20',
      author: 'Digital Strategy Team',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=Business%20team%20collaborating%20on%20digital%20transformation%20project%20with%20modern%20technology%20including%20tablets%20and%20interactive%20displays%2C%20innovative%20office%20space%20with%20digital%20interfaces%20and%20cloud%20computing%20visualization%2C%20professional%20collaborative%20environment&width=800&height=500&seq=blog5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Understanding UAE Corporate Tax: What Businesses Need to Know',
      excerpt: 'A detailed overview of the UAE corporate tax framework, compliance requirements, exemptions, and strategic planning considerations for businesses operating in the Emirates.',
      content: 'Full article content...',
      category: 'Tax Optimization',
      date: '2024-11-15',
      author: 'Tax Compliance Team',
      readTime: '9 min read',
      image: 'https://readdy.ai/api/search-image?query=Professional%20accountant%20analyzing%20UAE%20corporate%20tax%20regulations%20and%20compliance%20documents%20with%20financial%20reports%20and%20legal%20papers%20on%20modern%20desk%2C%20organized%20business%20environment%20with%20calculator%20and%20digital%20tools%2C%20professional%20office%20setting&width=800&height=500&seq=blog6&orientation=landscape'
    },
    {
      id: 7,
      title: 'Building a Resilient IT Infrastructure for Remote Work',
      excerpt: 'Essential strategies for creating robust IT infrastructure that supports remote and hybrid work models while maintaining security, productivity, and seamless collaboration.',
      content: 'Full article content...',
      category: 'IT Management',
      date: '2024-11-08',
      author: 'Network Solutions Team',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=Modern%20IT%20infrastructure%20setup%20showing%20cloud%20computing%20network%20architecture%20with%20servers%20and%20remote%20work%20connectivity%2C%20professional%20technology%20environment%20with%20network%20diagrams%20and%20digital%20infrastructure%20visualization%2C%20clean%20technical%20atmosphere&width=800&height=500&seq=blog7&orientation=landscape'
    },
    {
      id: 8,
      title: 'Market Entry Strategies for the Middle East Region',
      excerpt: 'Proven strategies for successfully entering and expanding in Middle Eastern markets, including cultural considerations, regulatory requirements, and partnership opportunities.',
      content: 'Full article content...',
      category: 'International Business',
      date: '2024-11-01',
      author: 'International Expansion Team',
      readTime: '11 min read',
      image: 'https://readdy.ai/api/search-image?query=Business%20professionals%20analyzing%20Middle%20East%20market%20entry%20strategies%20with%20regional%20maps%20and%20market%20data%20on%20presentation%20screens%2C%20modern%20conference%20room%20with%20international%20business%20atmosphere%20and%20strategic%20planning%20materials&width=800&height=500&seq=blog8&orientation=landscape'
    },
    {
      id: 9,
      title: 'Effective Leadership in Times of Business Transformation',
      excerpt: 'Key leadership principles and strategies for guiding organizations through periods of significant change, maintaining team morale, and achieving transformation objectives.',
      content: 'Full article content...',
      category: 'Business Insights',
      date: '2024-10-25',
      author: 'Leadership Advisory Team',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=Confident%20business%20leader%20presenting%20transformation%20strategy%20to%20executive%20team%20in%20modern%20boardroom%2C%20professional%20corporate%20environment%20with%20presentation%20screens%20and%20collaborative%20atmosphere%2C%20natural%20lighting%20and%20contemporary%20office%20design&width=800&height=500&seq=blog9&orientation=landscape'
    }
  ];

  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Auralis Consulting Blog",
    "description": "Latest insights on business consulting, corporate strategy, tax optimization, and international business setup in Ras Al Khaimah, UAE",
    "url": `${siteUrl}/blog`,
    "publisher": {
      "@type": "Organization",
      "name": "Auralis Consulting",
      "url": siteUrl
    }
  };

  return (
    <>
      <SEOHead
        title="Business Consulting Blog Ras Al Khaimah Corporate Strategy Tax Insights Auralis"
        description="Explore expert insights on business consulting, corporate strategy, tax optimization, international business setup, and IT management from Auralis Consulting in Ras Al Khaimah. Stay updated with the latest business trends, regulatory changes, and strategic advice for growing your business in the UAE and internationally."
        keywords="business consulting blog, corporate strategy insights, tax optimization news"
        canonical={`${siteUrl}/blog`}
        schemaData={schemaData}
      />
      <div className="min-h-screen bg-white">
        <Navigation />
        
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                Insights & News
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Stay informed with the latest trends, strategies, and expert advice in business consulting, tax optimization, and international business development
              </p>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts Grid */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article 
                  key={post.id}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img 
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <i className="ri-calendar-line mr-2"></i>
                      <span>{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                      <span className="mx-2">•</span>
                      <i className="ri-time-line mr-2"></i>
                      <span>{post.readTime}</span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                      {post.title}
                    </h3>
                    
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                          <i className="ri-user-line text-blue-600"></i>
                        </div>
                        <span className="text-sm text-gray-700 font-medium">{post.author}</span>
                      </div>
                      
                      <button className="text-blue-600 font-medium flex items-center hover:text-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                        Read More
                        <i className="ri-arrow-right-line ml-2"></i>
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-4xl text-white"></i>
            </div>
            <h2 className="text-4xl font-bold text-white mb-4">
              Subscribe to Our Newsletter
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Get the latest insights, industry news, and expert advice delivered directly to your inbox
            </p>
            
            <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-6 py-4 rounded-full text-gray-900 focus:outline-none focus:ring-4 focus:ring-blue-300"
                required
              />
              <button
                type="submit"
                className="px-8 py-4 bg-white text-blue-600 rounded-full font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Subscribe Now
              </button>
            </form>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
